import { useTranslate } from '@i18n';
import { Button, Modal, Text } from '@ui';

type SwingDeleteConfirmationModalProps = {
    isDeleting: boolean;
    onAccept: () => void;
    onDismiss: () => void;
};

export const SwingDeleteConfirmationModal = ({
    isDeleting,
    onAccept,
    onDismiss,
}: SwingDeleteConfirmationModalProps) => {
    const t = useTranslate();

    return (
        <Modal
            variant="partial"
            title={t('activity_navigation.delete_title')}
            onDismiss={onDismiss}
            open
            footer={{
                primary: (
                    <Button variant="destroy" onClick={onAccept} isLoading={isDeleting}>
                        {t('activity_navigation.item_delete')}
                    </Button>
                ),
                secondary: (
                    <Button variant="secondary" onClick={onDismiss} isDisabled={isDeleting}>
                        {t('generic_ui.cancel')}
                    </Button>
                ),
            }}
        >
            <Text variant="p">{t('activity_navigation.delete_confirmation')}</Text>
        </Modal>
    );
};
